"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./PredictiveSearch.css");
var Predictions = /** @class */ (function (_super) {
    __extends(Predictions, _super);
    function Predictions(props) {
        var _this = _super.call(this, props) || this;
        _this._onClick = _this._onClick.bind(_this);
        return _this;
    }
    /* istanbul ignore next */
    Predictions.prototype._onClick = function (index, text) {
        this.props.onClick && this.props.onClick(index, text);
    };
    Predictions.prototype._getPredictionsProps = function () {
        var _this = this;
        var _a = this.props, id = _a.id, width = _a.width, predictions = _a.predictions, noPredictionsMessage = _a.noPredictionsMessage, coordinates = _a.coordinates;
        var cssPredictions = ['p-predictions'];
        var inlineStyle = {
            top: coordinates && coordinates.top,
            left: coordinates && coordinates.left
        };
        if ((coordinates && (coordinates.top === null && coordinates.left === null)) || // Predictions is not positioned
            (predictions && predictions.length < 1) || // Predictions is empty
            (!predictions && !noPredictionsMessage)) {
            // Predictions is null
            cssPredictions.push('dislocated');
        }
        if (width && width !== 'Auto') {
            if (typeof width === 'number') {
                inlineStyle['width'] = width + "px";
            }
            else {
                cssPredictions.push(width.toLowerCase());
            }
        }
        return {
            ref: function (r) {
                _this._refPredictionsInner = r;
            },
            className: cssPredictions.join(' '),
            style: inlineStyle,
            role: 'listbox',
            id: id
        };
    };
    Predictions.prototype.render = function () {
        var _this = this;
        var _a = this.props, predictions = _a.predictions, noPredictionsMessage = _a.noPredictionsMessage, predictionsIsOpen = _a.predictionsIsOpen, focusedPrediction = _a.focusedPrediction;
        return (React.createElement("ul", __assign({}, this._getPredictionsProps()), predictionsIsOpen && predictions === null && noPredictionsMessage ? (React.createElement("li", { className: "p-prediction no-results" }, noPredictionsMessage)) : (predictions &&
            predictions.map(function (item, index) {
                var cssPrediction = ['p-prediction'];
                if (index === focusedPrediction) {
                    cssPrediction.push('focused');
                }
                return (React.createElement("li", { onClick: function () { return _this._onClick(index, item.text); }, id: item.itemId, className: cssPrediction.join(' '), role: "option", key: index }, item.text));
            }))));
    };
    Predictions.defaultProps = {
        id: '',
        width: 'Block',
        predictions: [],
        coordinates: {
            top: 0,
            left: 0
        }
    };
    return Predictions;
}(React.Component));
exports.Predictions = Predictions;
exports.default = Predictions;
//# sourceMappingURL=Predictions.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/predictive-search/build/control/Predictions.js
// module id = 666
// module chunks = 0